import { API_ENDPOINT, fetchWithAuth, parseApiResponse } from "./index";

export interface RefundRequest {
  id: number;
  status: string;
  reason: string;
  amountPence: number;
  createdAt: string;
  reviewedAt: string | null;
  reviewNote: string | null;
  stripeRefundId: string | null;
  order: {
    id: number;
    orderNumber: string | null;
    status: string;
    totalAmountPence: number;
    currency: string;
  };
  event: { title: string; slug: string };
}

export async function createRefundRequest(
  orderId: number,
  reason: string,
): Promise<RefundRequest> {
  const response = await fetchWithAuth(`${API_ENDPOINT}/refund-requests`, {
    method: "POST",
    body: JSON.stringify({ orderId, reason }),
  });
  const data = await parseApiResponse<{ request: RefundRequest }>(response);
  return data.request;
}

export async function getMyRefundRequests(): Promise<RefundRequest[]> {
  const response = await fetchWithAuth(`${API_ENDPOINT}/refund-requests/me`);
  const data = await parseApiResponse<{ requests: RefundRequest[] }>(response);
  return data.requests;
}
